export enum EModuleType {
  UNKNOWN = 0,
  SUITE = 1,
  IMAGER = 2,
  CHAMBER = 3,
  LOADPORT = 4,
  PSR = 5,
  CHILLER = 6,
  RIP = 7,
  FIS = 8,
}
